import { render, staticRenderFns } from "./CreateUpdate.vue?vue&type=template&id=abb80da8"
import script from "./CreateUpdate.vue?vue&type=script&lang=js"
export * from "./CreateUpdate.vue?vue&type=script&lang=js"
import style0 from "./CreateUpdate.vue?vue&type=style&index=0&id=abb80da8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports